<template>
  <div class="bg-primary footer no-print">
    <div class="container container-fixed-lg">
      <div class="copyright sm-text-center">
        <p class="small no-margin text-center">
          <span class="sm-block">
            <a :href=externalLinks.legalNotice class="m-r-10 footer-link" target="_blank">Mentions légales</a>
            <span class="muted">|</span>
            <a :href=externalLinks.termsOfService class="m-l-10 m-r-10 footer-link" target="_blank">CGU</a>
            <span class="muted">|</span>
            <a :href=externalLinks.privacyPolicy class="m-l-10 m-r-10 footer-link" target="_blank">Politique de confidentialité</a>
            <span class="muted">|</span>  
            <span class="muted">|</span>
            <a :href=externalLinks.support class="m-l-10 m-r-10 footer-link" target="_blank">Support</a>
            <span class="muted">|</span>
            <a :href=externalLinks.faq class="m-l-10 footer-link" target="_blank">FAQ</a>
          </span>
        </p>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="text-center">
      <a :href=externalLinks.appstore class="m-l-10" target="_blank">
        <img src="../../assets/img/button_app_store.svg" class="appstore">
      </a>
      <a :href=externalLinks.googleplay class="m-l-10" target="_blank">
        <img src="../../assets/img/button_google_play.png" class="googleplay">
      </a>
    </div>
  </div>
</template>

<script type="text/javascript">
  import { externalLinks } from '@/settings/externalLinks'

  export default {
    computed: {
      externalLinks() {
        return externalLinks
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/pages/_var.scss';
  .footer {
    a, a:hover {
      color: $color-white;
    }

    .copyright {
      border-top: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/AppFooter.vue